<script lang="ts">
	/*
		App.svelte

		Component root for the TCARE Connect frontend app.
		Repo: TCARE1/rdb-ui

		to launch Docker containers:
			nav to /src/github.com/rdb-api
			launch Docker Desktop (Mac)
			docker compose up database es01 es02 es03 
			docker compose build database es01 es02 es03 

		to start server:
			go run ./cmd/rdb-api --skip-authorization 

		
		1.	create new Svelte project "npx degit sveltejs/template tcare-connect"

		2.	delete unused Svelte boilerplate code - move global.css to /public/css

		3.	npm install --save svelte-material-ui - copy bare.css to /public/css

		4.	add <link rel="stylesheet" href="/css/bare.css" />		(SMUI CSS)

		5.	add <link rel="stylesheet" href="/css/flexi.css" />		(custom responsive CSS)



		6.	follow the instructions for custom SMUI theming
		
		7.	npm install --save-dev smui-theme (and all the other instructions)

		8.	as of April 2022 this installs version ^6.0.0-beta.15 - be careful!

		9.	npx smui-theme template src/theme - creates src/themes/_smui-theme.css

		10.	add to package.json scripts: "prepare": "smui-theme compile public/build/smui.css -i src/theme",

		11.	npm run prepare (and also each time new SMUI package is added)

		12.	<link rel="stylesheet" href="/build/smui.css" />

		13.	EDIT _smui-theme.css to include the following:

				@use '@material/theme/index' as theme with (
					$primary: #381b51,      // a.k.a. --tcare-primary
					$secondary: #ff3f23,    // a.k.a. --tcare-secondary
					etc...
				);	

		14.	EDIT global.css to include the following:

				:root {
					--tcare-primary: #381b51;
					--tcare-secondary: #ff3f23;
					--tcare-white: #ffffff;
					--tcare-disabled: #aaaaaa;
					etc...
				}



		15.	optional - use "flexi" styles in HTML: 
		
				<p class="fs-2 ta-c primary border-gray w-50 p-1 m-auto">TCARE primary</p>

		16.	npm install svelte-spa-router (may change to another...)

		17.	add the following subdirectories under /src for organization:

				/api				fetcher, API calls, services, etc.
				/common				routes, session storage, etc.
				/components			all comps used on pages - can be sub-nested
				/pages				main "Page" comps called by router
				/stores				persistent shared data - search params, results, user


		18.	use approved TCARE favicon, logos, colors, images, etc.

		19.	npm install @mdi/font (Material Design fonts)

		20.	npm i -D @smui/icon-button (and do this for ALL other SMUI component!)

		21.	must supply this top level <App> component with the Router!

		22.	fix warning in console regarding /node_modules/tslib/package.json

		23.	<Router> is now in BaseLayoutPage - not here

		24.	edit node_modules/tslib/package.json and change "./" to "./*"
			this will get rid of the Svelte compiler warning

			"exports": {
				".": {
					"module": "./tslib.es6.js",
					"import": "./modules/index.js",
					"default": "./tslib.js"
				},
				"./*": "./"
			}


	*/

	import { onMount } from 'svelte';
	import { loadTaxonomies } from './common/master-objects.js';
	import BaseLayoutPage from './pages/auth/BaseLayoutPage.svelte';

	import { isWindowNarrowView, isWindowMediumView, isWindowWideView } from './stores/ScreenSettingsStore.js';

	let taxonomiesData = null;

    const mqlNarrow = window.matchMedia('(max-width: 600px)');
    const mqlMedium = window.matchMedia('(min-width: 601px) and (max-width: 1300px)');
    const mqlWide = window.matchMedia('(min-width: 1301px)');
	const resizeEvent = new Event('resize');

    onMount(async () => {
		// console.log('');
		// console.log('<App> root component mounted');
		
		// calling this here now - not in auth.js
		taxonomiesData = await loadTaxonomies(true);			// true means public call

		// console.log('<App> root dispatching window resizeEvent: ', resizeEvent);
		window.dispatchEvent(resizeEvent);
	})

	// these stores can be checked to render conditional HTML
	const handleResizeEvent = () => {
		$isWindowNarrowView = mqlNarrow.matches;
		$isWindowMediumView = mqlMedium.matches;
		$isWindowWideView = mqlWide.matches;
		// console.log('App handleResizeEvent');
		// console.log('$isWindowNarrowView: ' + $isWindowNarrowView);
	}

</script>

<div>
	<div class="App">
		{#if taxonomiesData}
			<BaseLayoutPage />
		{/if}
		<!-- else show a spinner here? -->
	</div>
</div>

<!-- sets store variables on window resize -->
<!-- we can then display different HTML content -->
<svelte:window on:resize={handleResizeEvent}/>